var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container sidebar"},[_c('div',{staticClass:"sidebar-content"},[_vm._t("sidebar")],2),_c('div',{staticClass:"sidebar-after"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }